import styled from "styled-components";

export const Div = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
